export default {"src":"/_next/static/media/announcement-circular.42e9f078.svg","height":137,"width":139,"blurWidth":0,"blurHeight":0};